'use client'

import { StreamEvent } from '@langchain/core/tracers/log_stream'
import { getLanggraphEventHandler } from './common'
import { SessionContextValue } from 'next-auth/react'
import { Toast } from '@base-ui-components/react/toast'

export const receiveStream = async (args: {
  body: unknown
  doneCallback: (events: StreamEvent[]) => void
  onChatStream: (event: StreamEvent) => void
  update: SessionContextValue['update']
  toastManager: Toast.useToastManager.ReturnValue
}) => {
  const { body, doneCallback, onChatStream, update, toastManager } = args
  const res = await fetch('/api/stream', {
    method: 'POST',
    body: JSON.stringify(body)
  })
  const reader = res.body?.getReader()
  const decoder = new TextDecoder()
  if (!reader) return

  const _streamEvents: StreamEvent[] = []
  while (true) {
    const { done, value } = await reader.read()
    if (done) {
      doneCallback(_streamEvents)
      break
    }
    const events = decoder
      .decode(value)
      .split('\n')
      .filter(line => line.startsWith('data: '))
      .map(line => line.replace('data: ', ''))

    for (const eventString of events) {
      try {
        const event = JSON.parse(eventString) as StreamEvent
        const { clientSideHandler } = getLanggraphEventHandler(
          event,
          _event => {
            onChatStream(_event)
            _streamEvents.push(_event)
          }
        )
        clientSideHandler?.(toastManager)
        if (
          event.event === 'on_chain_end' ||
          (event.event === 'on_chain_start' && event.name === 'LangGraph')
        ) {
          update()
        }
      } catch (err) {
        console.error('Invalid event JSON:', err)
        doneCallback(_streamEvents)
      }
    }
  }
}
